/* eslint-disable no-unused-vars */
// src/components/CollapseMenu.jsx
import React, { useState, useEffect, cloneElement } from 'react';
import { IoSearchOutline } from "react-icons/io5";
import useDebounce from '../hooks/useDebounce';

export default function CollapseMenu({ title, activeTab, children }) {
  const [isOpen, setIsOpen] = useState(true);
  const [value, setValue] = useState('');
  const searchTerm = useDebounce(value, 300);

  useEffect(() => {
    setValue('');
  }, [activeTab])

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  // Recursively clone any React element (including Fragments) with the searchTerm prop
  const cloneWithSearch = (node) => {
    if (React.isValidElement(node)) {
      // If it's a Fragment, dive into its children
      if (node.type === React.Fragment) {
        return (
          <React.Fragment>
            {React.Children.map(node.props.children, (child) => cloneWithSearch(child))}
          </React.Fragment>
        );
      }
      // Otherwise, clone this element with the new prop
      return cloneElement(node, { searchTerm });
    }
    // Non-element (string, number, etc.) — leave alone
    return node;
  };

  return (
    <div data-testid="collapse-menu-container" className="collapse-container">
      {/* Header with search input */}
      <button
        data-testid="collapse-menu-search"
        className="w-full text-left flex items-center"
        style={{
          padding: '6px 10px',
          border: '1px solid #E4E4E7',
          borderRadius: 0,
          background: '#FFFFFF',
          fontFamily: "'IBM Plex Sans', sans-serif",
          fontSize: '0.78rem',
          color: '#09090B',
          transition: 'border-color 0.15s ease'
        }}
      >
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder={title}
          className="flex-grow bg-transparent outline-none"
          data-testid="product-search-input"
          style={{
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: '0.78rem',
            color: '#09090B'
          }}
        />
        <IoSearchOutline style={{ color: '#A1A1AA', fontSize: '14px' }} />
      </button>

      {/* Expand/collapse content */}
      <div className={`collapse-content ${isOpen ? "open" : ""}`}>
        {cloneWithSearch(children)}
      </div>
    </div>
  );
}
